<template>
    <b-modal size="md" hideHeader v-model="modalVisible" title="Select Customer Information" @hidden="onHidden">
      <div v-if="needsOptions(customer.address)">
        <h5>Select Address:</h5>
        <b-form-group>
          <b-row>
            <b-col class="flex-fill" md="6" v-for="(option, index) in addressOptions" :key="index">
              <b-form-radio class="mb-4" v-model="selectedAddress" :value="option.value">
                <div v-html="option.html"></div>
              </b-form-radio>
            </b-col>
          </b-row>
        </b-form-group>
      </div>
  
      <div v-if="needsOptions(customer.phone)" class="mt-3">
        <h5>Select Phone:</h5>
        <b-form-group>
          <b-form-radio-group v-model="selectedPhone" :options="phoneOptions" />
        </b-form-group>
      </div>
  
      <div v-if="needsOptions(customer.email)" class="mt-3">
        <h5>Select Email:</h5>
        <b-form-group>
          <b-form-radio-group v-model="selectedEmail" :options="emailOptions" />
        </b-form-group>
      </div>
  
      <template #modal-footer="{  }">
                <b-button size="sm" class="mb-0" @click="submitSelection" :disabled="!isSelectionValid()" variant="success">
                    <b-icon-check-square-fill></b-icon-check-square-fill>
                    <span class="p-xl-2 pl-2 pr-1">Create Order</span>
                </b-button>

                <b-button size="sm" class="mb-0" @click="cancelSelection" variant="secondary">
                    <b-icon-x-square-fill></b-icon-x-square-fill>
                    <span class="p-xl-2 pl-2 pr-1">Cancel</span>
                </b-button>
            </template>
    </b-modal>
  </template>
  
  <script>
  export default {
    name: "CustomerBuilderModal",
    props: ["customer"],
    data() {
      return {
        modalVisible: true,
        selectedAddress: null,
        selectedPhone: null,
        selectedEmail: null,
      };
    },
    computed: {
      addressOptions() {
        if (this.needsOptions(this.customer.address)) {
          return this.customer.address.map((address, index) => {
            const lines = [];

            if (address.name) {
            lines.push(`<strong>${address.name}</strong>`);
            }

            if (address.line1) {
            lines.push(`<span>${address.line1}</span>`);
            }

            if (address.line2) {
            lines.push(`<span>${address.line2}</span>`);
            }

            if (address.line3) {
              lines.push(`<span>${address.line3}</span>`);
            }

            let cityStateZip = "";
            if (address.city) {
            cityStateZip += `${address.city}`;
            }
            if (address.state) {
            cityStateZip += `, ${address.state}`;
            }
            if (address.zip) {
            cityStateZip += `, ${address.zip}`;
            }
            if (cityStateZip) {
            lines.push(`<span>${cityStateZip}</span>`);
            }

            if (address.country) {
            lines.push(`<span>${address.country}</span>`);
            }

            return {
            value: index,
            html: lines.join("<br>"),
            };
          });
        } else {
          return [];
        }
      },
      phoneOptions() {
        if (this.needsOptions(this.customer.phone)) {
          return this.customer.phone.map((phone, index) => {
            return {
              value: index,
              text: phone.number,
            };
          });
        } else {
          return [];
        }
      },
      emailOptions() {
        if (this.needsOptions(this.customer.email)) {
          return this.customer.email.map((email, index) => {
            return {
              value: index,
              text: email,
            };
          });
        } else {
          return [];
        }
      },
    },
    methods: {
      needsOptions(arr) {
        return Array.isArray(arr) && arr.length > 1;
      },
      onChange(type, value) {
        this.onChangeData[type] = value;
      },
      onHidden() {
        this.$emit("modalClosed", this.onChangeData);
      },
      submitSelection() {
      // Create a new customer object with selected values
      const selectedCustomer = {
        _id: this.customer._id,
        fullName: this.customer.fullName || '',
        address: this.selectedAddress !== null
          ? this.customer.address[this.selectedAddress]
          : this.customer.address[0] || null,
        phone: this.selectedPhone !== null
          ? this.customer.phone[this.selectedPhone].number
          : this.customer.phone[0].number || null,
        email: this.selectedEmail !== null
          ? this.customer.email[this.selectedEmail]
          : this.customer.email[0] || null,
        customerId: this.customer.customerId || null,
      };
      this.$emit("modalClosed", selectedCustomer);
      this.modalVisible = false;
    },
    cancelSelection() {
      this.modalVisible = false;
      this.$emit("modalClosed", null);
    },

    isSelectionValid() {
      const isAddressValid = !this.needsOptions(this.customer.address) || this.selectedAddress !== null && this.selectedAddress !== undefined;
      const isPhoneValid = !this.needsOptions(this.customer.phone) || this.selectedPhone !== null && this.selectedPhone !== undefined;
      const isEmailValid = !this.needsOptions(this.customer.email) || this.selectedEmail !== null && this.selectedEmail !== undefined;

      return isAddressValid && isPhoneValid && isEmailValid;
    },
    },
  };
  </script>
  
  <style scoped>

  </style>
  